import ROUTE_PATHS from "src/routes/route-path"
import { useTypedSelector } from "src/shared/store/store"
// import ROUTE_PATHS from "path/to/routePaths"
import { validate as validateUUID } from "uuid"
export interface BreadcrumbItem {
  path?: string
  label: string
}

export const breadcrumbRoutes: BreadcrumbItem[] = [
  { path: ROUTE_PATHS.LOGIN, label: "Login" },
  { path: ROUTE_PATHS.DASHBOARD, label: "Dashboard" },
  { path: ROUTE_PATHS.INVOICE_PARTICULAR, label: "Invoice Particular" },
  { path: ROUTE_PATHS.CUSTOMER, label: "Customer" }
]
const invalidPaths = [""]

export const getBreadcrumbItems = (currentPath: string): BreadcrumbItem[] => {
  const pathSegments = currentPath.split("/").filter(Boolean) // Split and remove empty segments
  let accumulatedPath = ""
  const breadcrumbState = useTypedSelector(state => state.breadcrumb)
  const res = []
  for (const segment of pathSegments) {
    console.log("segment", segment)
    accumulatedPath += `/${segment}`
    const matchingRoute = breadcrumbRoutes.find(
      route => route.path === accumulatedPath || route?.path?.includes(`:${segment}`)
    )
    let label = segment
    let path: undefined | string = accumulatedPath
    if (invalidPaths.includes(segment)) {
      path = undefined
    }
    if (!matchingRoute && validateUUID(segment) && breadcrumbState.id == segment) {
      path = undefined
      label = breadcrumbState.label
    }

    // if (accumulatedPath.includes("update")) {
    //   const id = pathSegments[pathSegments.length - 1]
    //   if (breadcrumbState.id == id) {
    //     res.push({
    //       path: `${accumulatedPath}/update/${id}`,
    //       label: breadcrumbState.label
    //     })
    //   } else {
    //     res.push(
    //       ...[
    //         {
    //           label: `Update`
    //         },
    //         { label: id }
    //       ]
    //     )
    //   }

    //   break
    // }
    res.push({
      path: path,
      label: matchingRoute?.label || label
    })
  }

  return res
}

// ------------- OLD Code ---------------

// import { useTypedSelector } from "src/shared/store/store"

// export interface BreadcrumbItem {
//   path?: string
//   label: string
// }

// export const breadcrumbRoutes: BreadcrumbItem[] = [{ path: "/app", label: "App" }]

// export const getBreadcrumbItems = (currentPath: string): BreadcrumbItem[] => {
//   const pathSegments = currentPath.split("/").filter(Boolean) // Split and remove empty segments
//   let accumulatedPath = ""
//   const breadcrumbState = useTypedSelector((state) => state.breadcrumb)
//   console.log("currentPath", { currentPath, pathSegments })
//   const res = []
//   for (const segment of pathSegments) {
//     accumulatedPath += `/${segment}`
//     const matchingRoute = breadcrumbRoutes.find(
//       (route) => route.path === accumulatedPath || route?.path?.includes(`:${segment}`)
//     )
//     if (accumulatedPath.includes("update")) {
//       const id = pathSegments[pathSegments.length - 1]
//       if (breadcrumbState.id == id) {
//         res.push({
//           path: `${accumulatedPath}/update/${id}`,
//           label: breadcrumbState.label
//         })
//       } else {
//         res.push(
//           ...[
//             {
//               label: `Update`
//             },
//             { label: id }
//           ]
//         )
//       }

//       break
//     }
//     res.push({
//       path: accumulatedPath,
//       label: matchingRoute?.label || segment
//     })
//   }

//   return res
// }
